import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { circleApi } from 'container/circleApi';

import { STORE_NAME } from './initialState';

export const fetchCircles = createAsyncThunk(
  `${STORE_NAME}/fetchCircles`,
  () => {
    return circleApi.fetch();
  },
  { serializeError },
);
